/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Badge_Alt1Inputs */

const vi_sitesettings_brand_badge_alt1 = /** @type {(inputs: Sitesettings_Brand_Badge_Alt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả ảnh (alt)`)
};

/**

* @param {Sitesettings_Brand_Badge_Alt1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_badge_alt1 = /** @type {((inputs?: Sitesettings_Brand_Badge_Alt1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Badge_Alt1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_badge_alt1(inputs)
});
export { sitesettings_brand_badge_alt1 as "siteSettings_brand_badge_alt" }